import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import styles from "../hik.module.css";

const KhIpBased = () => {
  const { t } = useTranslation();
  return (
    <motion.div
      className={styles.productDetails}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <motion.div
        className={styles.productImage}
        initial={{ x: -200 }}
        animate={{ x: 0 }}
        transition={{ type: "spring", stiffness: 100 }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/05-hikvision/cam/intercom/details/Kh6IpBased/01.jpg`}
          alt="Product"
        />
      </motion.div>
      <motion.div
        className={styles.productInfo}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <motion.h1
          className={styles.productTitle}
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          {t("kh6SeriesIpBased.title")}
        </motion.h1>
        <motion.ul className={styles.productFeatures}>
          {[
            "kh6SeriesIpBased.feature1",
            "kh6SeriesIpBased.feature2",
            "kh6SeriesIpBased.feature3",
            "kh6SeriesIpBased.feature4",
            "kh6SeriesIpBased.feature5",
            "kh6SeriesIpBased.feature6",
            "kh6SeriesIpBased.feature7",
            "kh6SeriesIpBased.feature8",
            "kh6SeriesIpBased.feature9",
            "kh6SeriesIpBased.feature10",
            "kh6SeriesIpBased.feature11",
          ].map((feature, index) => (
            <motion.li
              key={index}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.4 + index * 0.2, duration: 0.6 }}
            >
              {t(feature)}
            </motion.li>
          ))}
        </motion.ul>
      </motion.div>
    </motion.div>
  );
};

export default KhIpBased;
